import React from 'react';
import '../styles/ASZFModal.css';

const ASZFModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="aszf-modal-overlay" onClick={onClose}>
      <div className="aszf-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="aszf-modal-close" onClick={onClose}>×</button>
        
        <div className="aszf-modal-body">
          <h2>Általános Szerződési Feltételek</h2>
          <p className="aszf-date">Hatályos: 2025. február 15-től</p>

          <section>
            <h3>1. Általános rendelkezések</h3>
            <p>
              Jelen Általános Szerződési Feltételek (ÁSZF) szabályozzák a 
              <strong> Kismanócuki Szeged</strong> (székhely: 6724 Szeged, Kossuth Lajos sgt. 45.) 
              által üzemeltetett online tortarendelési szolgáltatás igénybevételének feltételeit.
            </p>
          </section>

          <section>
            <h3>2. A szolgáltatás tárgya</h3>
            <p>
              A Kismanócuki Szeged cukrászda különféle tortákat és süteményeket kínál előrendelésre.
            </p>
            <ul>
              <li>Minimum rendelési idő: 72 óra a kívánt átvételi időpont előtt</li>
              <li>Átvétel helye: 6724 Szeged, Kossuth Lajos sgt. 45.</li>
              <li>Fizetés módja: Személyes átvételkor, készpénzzel vagy bankkártyával</li>
            </ul>
          </section>

          <section>
            <h3>3. Árak és fizetés</h3>
            <ul>
              <li>Az árak forintban (Ft) értendők, ÁFÁ-t tartalmaznak</li>
              <li>Fizetés az átvételkor történik</li>
              <li>Foglalót nem kérünk</li>
            </ul>
          </section>

          <section>
            <h3>4. Lemondás és módosítás</h3>
            <p><strong>Vásárló részéről:</strong></p>
            <ul>
              <li>Lemondás telefonon vagy emailen lehetséges</li>
            </ul>
          </section>

          <section>
            <h3>5. Adatkezelés</h3>
            <p>
              A megadott személyes adatokat (név, email, telefon) kizárólag a rendelés 
              teljesítéséhez és marketing célokra (ha hozzájárult) használjuk fel. 
              Az adatokat a rendelés teljesítésétől számított 1 éven belül töröljük.
            </p>
          </section>

          <section>
            <h3>6. Marketing kommunikáció</h3>
            <p>
              Ha hozzájárult a marketing kommunikációhoz, hírleveleket, akciókat és 
              újdonságokat küldhetünk emailben. Bármikor leiratkozhat.
            </p>
          </section>

          <section>
            <h3>7. Kapcsolat</h3>
            <p><strong>Kismanócuki Szeged</strong></p>
            <p>Cím: 6724 Szeged, Kossuth Lajos sgt. 45.</p>
            <p>Email: info@kismanocukiszeged.hu</p>
            <p>Telefon: +36 30 123 4567</p>
          </section>
        </div>

        <div className="aszf-modal-footer">
          <button className="aszf-close-btn" onClick={onClose}>
            Bezárás
          </button>
        </div>
      </div>
    </div>
  );
};

export default ASZFModal;